<app-parentapp-header></app-parentapp-header>
<app-student-progress-report></app-student-progress-report>
<app-parentapp-footer></app-parentapp-footer>